/**
 * Super-admin → tenant impersonation contracts (M23).
 *
 * Routes (server):
 *   POST /admin/impersonate/:tenantId        → StartImpersonationResponse
 *   POST /admin/impersonate/exit             → 204 (no body)
 *   GET  /admin/impersonation-sessions       → { data: ImpersonationSessionDetail[] }
 */
import { z } from 'zod';

// ---------------------------------------------------------------------------
// Start impersonation
// ---------------------------------------------------------------------------

export const StartImpersonationParamsSchema = z.object({
  tenantId: z.string().uuid(),
});
export type StartImpersonationParams = z.infer<typeof StartImpersonationParamsSchema>;

export const StartImpersonationResponseSchema = z.object({
  jwt: z.string().min(1),
  expiresAt: z.string(),
  sessionId: z.string().uuid(),
  targetTenantId: z.string().uuid(),
  targetUserId: z.string().uuid(),
  targetUserEmail: z.string(),
});
export type StartImpersonationResponse = z.infer<typeof StartImpersonationResponseSchema>;

// ---------------------------------------------------------------------------
// Audit history
// ---------------------------------------------------------------------------

export const ImpersonationSessionDetailSchema = z.object({
  id: z.string().uuid(),
  superAdminUserId: z.string().uuid(),
  superAdminEmail: z.string(),
  targetTenantId: z.string().uuid(),
  targetTenantName: z.string(),
  targetUserId: z.string().uuid(),
  targetUserEmail: z.string(),
  startedAt: z.string(),
  endedAt: z.string().nullable(),
  ipAddress: z.string().nullable(),
  userAgent: z.string().nullable(),
  actionCount: z.number().int().nonnegative(),
});
export type ImpersonationSessionDetail = z.infer<typeof ImpersonationSessionDetailSchema>;

export const ImpersonationHistoryResponseSchema = z.object({
  data: z.array(ImpersonationSessionDetailSchema),
});
export type ImpersonationHistoryResponse = z.infer<typeof ImpersonationHistoryResponseSchema>;
